export default {
  pagingRow: '{start} - {stop} of {length}',
  all: 'All',
  noData: 'No data available',
  rowsPerPage: 'Rows per page:',
  soupsCount: 'Soups Count:',
  mainsCount: 'Main dishes Count:',
};
